module.exports = __webpack_public_path__ + "static/media/banner_fut_future_email.0c58fcf4.png";